import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { lazy } from 'react';
import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';

const Shippings = lazy(() => import('../Shippings'));
const CreateShippings = lazy(() => import('../pages/CreateShippings'));
const ViewShipping = lazy(() => import('../pages/ViewShipping'));
const EditShipping = lazy(() => import('../pages/EditShipping'));
const RouteBuilder = lazy(() => import('../pages/RouteBuilder'));
const ImportShippings = lazy(() => import('../pages/ImportShippings'));

const WRITE_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.all,
];

const ShippingsRoutes: RouteObject[] = [
  {
    path: 'shippings',
    element: <Shippings />,
  },
  {
    path: 'shipping/:number',
    element: <ViewShipping />,
  },
  {
    path: 'shipping/:number/edit',
    element: (
      <Authorize
        permission={WRITE_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <EditShipping />
      </Authorize>
    ),
  },
  {
    path: 'shippings/create',
    element: (
      <Authorize
        permission={WRITE_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <CreateShippings />
      </Authorize>
    ),
  },
  {
    path: 'shippings/routing',
    element: (
      <Authorize
        permission={WRITE_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <RouteBuilder />
      </Authorize>
    ),
  },
  {
    path: 'shippings/import',
    element: (
      <Authorize
        permission={EXTERNAL_OPERATOR_ROLE_GROUPS.all}
        fallback={<ErrorPage code={403} />}
      >
        <ImportShippings />
      </Authorize>
    ),
  },
];

export default ShippingsRoutes;
